export default {
  background: require('./images/global_bkg.jpg'),
  menu_background: require('./images/main_bkg.jpg'),
  menu_box_large: require('./images/Box_lg.png'),
  menu_box_small: require('./images/Box_sm.png'),
  menu_highlight: require('./images/bar_HL.png'),
  ipg_background: require('./images/ipg_bkg.jpg'),
  welcome_background: require('./images/PromoCh_bkg.jpg')
};
